import script from "./LoginCompVue.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginCompVue.vue?vue&type=script&setup=true&lang=js"

import "./LoginCompVue.vue?vue&type=style&index=0&id=3d6c623b&lang=scss"

const __exports__ = script;

export default __exports__